import { defineComponent as _defineComponent } from 'vue'
import ToggleButton from '@/ui-components/ToggleButton.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { isFilterActive as filterActive } from '@/helpers/filter-helper';
import { useFilterStore } from '@/helpers/composables/useStores';
import { FilterCollection, FilterName } from '@/stores/filter.store';

import { OfferPresentationType, OfferPresentationTypes } from '@/interfaces/titles';
import { CollectionType } from '../../enums/collection-type';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPresentationTypes',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};



const { filters, toggle } = useFilterStore();

function isFilterActive(filterName: FilterName, value: any) {
	return filterActive(filterName, value, filters.value(props.collectionType));
}

function clicked(presentationType: OfferPresentationType) {
	const selectedState = isFilterActive('presentation_types', presentationType) ? 0 : 1;
	toggle({
		filterName: 'presentation_types',
		value: presentationType,
		selectedState,
	});
}

return { __sfc: true,props, filters, toggle, isFilterActive, clicked, ToggleButton, ResetButton, OfferPresentationTypes }
}

})